import { makeAuthenticatedApiCall } from '../apiHelper';
import { describePieceDetachError, isPieceNotReferenced } from './cfnPieces';

/**
 * Retire une pièce du dossier côté base AVANT que `FirebaseUploadComponent`
 * ne supprime l'objet Storage (prop `onBeforeDelete`). Lève une Error dont le
 * message est affichable telle quelle ; un 404 (aucune référence en base) ne
 * bloque pas : il n'y a rien à retirer, la suppression Storage peut suivre.
 */
export const requestPieceDetachment = async (endpoint: string, url: string): Promise<void> => {
  try {
    await makeAuthenticatedApiCall('delete', endpoint, { url });
  } catch (error) {
    if (isPieceNotReferenced(error)) return;
    throw new Error(describePieceDetachError(error));
  }
};

/** Endpoints de retrait, un par source de pièces (même contrat `{ url }`). */
export const pieceDetachmentEndpoints = {
  cg: (registrationId: number | string) => `/api/cg/${registrationId}/documents`,
  da: (registrationId: number | string) => `/api/da/${registrationId}/documents`,
  deal: (pipedriveDealId: number | string) => `/api/deals/${pipedriveDealId}/procurement-file`,
  depositSaleBuyer: (pipedriveDealId: number | string) => `/api/misiv/deposit-sale-buyer/${pipedriveDealId}/files`,
};
